var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.253967,
    y: 0.189819,
    width: 26.2751,
    height: 24.9811,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_203_61",
    transform: "matrix(0.0416667 0 0 0.043825 0 -0.0259002)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_203_61",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABGElEQVRIDe2UsQ3CMBBFHZZgAcaACWAGhMQQtAhEQYGERAdMAytAlU1ozPtXIDvYIYSCJtG9C7779wNWsHPd1WYHvPclhPHI+SCq1RapQYZmzrk+TGAIruDSvUqgHdMbQVarnsFQD06guChZI5HoFXAERa3WxlH14AyKNWkJ3pqVRD0037DOam0UQWi+UpHaFO76HEItMlePWlKrnoFgD4qdFTIJwZt5RhqXGbzBNq7GK/rtzGOb9KozT+7L37eFL1BCGNljJfoFTDR6W9DNYAFXsIiMUgtUjcw1i1Z/zhN3xUVJ9SwIvjVvdKzYA38wrz1WzFyJB2g/ufkDKXmUSyfoNzpWpH3B0ADmUGuuATQfjxXpOj7uwBPdpOQ8R+qL5gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.8ff7e8c444679e1420478ddce384a369.svg";
export { ForwardRef as ReactComponent };